/**
 * Auto-generated file created by svgr-cli source svgr.template.config.js
 * Run yarn svgr to update
 * Do not edit
 */
import * as React from 'react'
import { SVGProps, memo } from 'react'
const SvgTransactionOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || 24}
    height={props.height || 24}
    fill="currentColor"
    viewBox="0 0 20 20"
    color={props.color || '#EE4D2D'}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.006 18.75c-1.419 0-2.57-1.183-2.57-2.617v-4.347h1.463v4.345a1.12 1.12 0 0 0 1.107 1.127h11.163a1.12 1.12 0 0 0 1.107-1.127V3.88c0-.625-.503-1.128-1.107-1.128H6.93V1.25h9.24c1.418 0 2.58 1.183 2.58 2.627v12.241c0 1.444-1.162 2.628-2.58 2.628H5.006v.004Zm10.462-4.3h-5.192v-1.318h5.192v1.318Zm.34-7.51H9.306V5.623h6.504V6.94Zm-.34 3.687h-3.084V9.31h3.084v1.319ZM9.591 8.931a.17.17 0 0 0 .003-.246l-3.12-3.083a.064.064 0 0 0-.064-.014.057.057 0 0 0-.037.053l-.03 1.83c-1.03-.018-3.651-.085-3.607-2.764a2.905 2.905 0 0 1 2.38-2.804c-2.144.252-3.828 2.026-3.864 4.23-.068 4.095 4.333 4.205 5.043 4.217l-.025 1.537a.06.06 0 0 0 .035.054c.023.01.05.004.066-.011l3.22-3Z"
      clipRule="evenodd"
    />
  </svg>
)
const Memo = memo(SvgTransactionOutlined)
export default Memo
